/**
 * The map's entry point — and the code-split boundary. MapLibre plus the pmtiles
 * protocol adapter is ~230 kB gzip; `/plans`, the sign-in page and a pilot who
 * only ever fills in the Formular must not download it, so nothing outside this
 * file may import `./MapView` directly.
 */
import { Suspense, lazy } from 'react';
import { useT } from '../i18n';
import type { RouteMapProps } from './MapView';

const MapView = lazy(() => import('./MapView'));

export function RouteMap(props: RouteMapProps) {
  const t = useT();
  return (
    <Suspense fallback={<div className="mapwrap"><div className="maploading">{t('map.loading')}</div></div>}>
      <MapView {...props} />
    </Suspense>
  );
}

export type { RouteMapProps };
